import React, { useState, useEffect, useCallback } from 'react';
import { X } from 'lucide-react';

export function SideDrawer({ testId, icon: Icon, kicker, title, subtitle, width = 820, onClose, children }) {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const t = requestAnimationFrame(() => setOpen(true));
    return () => cancelAnimationFrame(t);
  }, []);
  const close = useCallback(() => { setOpen(false); setTimeout(onClose, 220); }, [onClose]);
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') close(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [close]);

  return (
    <div data-testid={testId} style={{ position: 'fixed', inset: 0, zIndex: 1000 }}>
      <div onClick={close} style={{ position: 'absolute', inset: 0, background: 'rgba(15,23,42,0.45)', opacity: open ? 1 : 0, transition: 'opacity 0.2s ease' }} />
      <aside role="dialog" aria-modal="true" aria-label={title} style={{
        position: 'absolute', top: 0, right: 0, height: '100%', width: `min(${width}px, 94vw)`, background: '#fff',
        boxShadow: '-12px 0 40px rgba(15,23,42,0.2)', display: 'flex', flexDirection: 'column',
        transform: open ? 'translateX(0)' : 'translateX(100%)', transition: 'transform 0.22s cubic-bezier(0.4,0,0.2,1)',
      }}>
        <div style={{ padding: '18px 24px', borderBottom: '1px solid #e2e8f0', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 16 }}>
          <div style={{ display: 'flex', gap: 12, minWidth: 0 }}>
            {Icon && (
              <div style={{ width: 40, height: 40, borderRadius: 10, background: '#eef2ff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <Icon size={20} color="#4338ca" />
              </div>
            )}
            <div style={{ minWidth: 0 }}>
              {kicker && <div style={{ fontSize: 11, color: '#64748b', textTransform: 'uppercase', letterSpacing: 0.5, fontWeight: 700 }}>{kicker}</div>}
              <div style={{ fontSize: 17, fontWeight: 700, color: '#0f172a' }} data-testid={`${testId}-title`}>{title}</div>
              {subtitle && <div style={{ fontSize: 13, color: '#475569', marginTop: 2 }}>{subtitle}</div>}
            </div>
          </div>
          <button onClick={close} data-testid={`${testId}-close-btn`} aria-label="Close" style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 6, borderRadius: 6, color: '#64748b' }}>
            <X size={20} />
          </button>
        </div>
        <div style={{ flex: 1, overflow: 'auto', padding: '20px 24px' }}>{children}</div>
      </aside>
    </div>
  );
}

export function ProgressBar({ pct, testId }) {
  const v = Math.max(0, Math.min(100, Number(pct) || 0));
  const color = v >= 100 ? '#16a34a' : v >= 50 ? '#4338ca' : v > 0 ? '#f59e0b' : '#cbd5e1';
  return (
    <div data-testid={testId} title={`${v}%`} style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 120 }}>
      <div style={{ flex: 1, height: 6, background: '#e2e8f0', borderRadius: 999, overflow: 'hidden' }}>
        <div style={{ width: `${v}%`, height: '100%', background: color, transition: 'width .3s ease' }} />
      </div>
      <span style={{ fontSize: 12, fontWeight: 600, color: '#334155', minWidth: 34, textAlign: 'right' }}>{Math.round(v)}%</span>
    </div>
  );
}
